import { FieldDescriptor } from "@shopify/react-form-state";
import { ISO8601Duration } from "@teams/types";
import moment from "moment";
import React, { useMemo } from "react";

import { DropdownField } from "../../../_shared/components/fields";

export const OpenDurationField: React.FC<{
  field: FieldDescriptor<ISO8601Duration | undefined>;
  label?: string;
  fluid?: boolean;
  allowManual: boolean;
  isMobile?: boolean;
}> = ({ field, label, fluid, allowManual, isMobile }) => {
  const options = useMemo(() => {
    const items: Array<{ key?: string; label: string; value: string | undefined }> = [
      {
        label: "5 Minutes",
        value: "PT5M",
      },
      {
        label: "15 Minutes",
        value: "PT15M",
      },
      {
        label: "30 Minutes",
        value: "PT30M",
      },
      {
        label: "1 Hour",
        value: "PT1H",
      },
      {
        label: "2 Hours",
        value: "PT2H",
      },
      {
        label: "3 Hours",
        value: "PT3H",
      },
      {
        label: "6 Hours",
        value: "PT6H",
      },
      {
        label: "12 Hours",
        value: "PT12H",
      },
      {
        label: "1 day",
        value: "P1D",
      },
      {
        label: "2 days",
        value: "P2D",
      },
      {
        label: "3 days",
        value: "P3D",
      },
      {
        label: "5 days",
        value: "P5D",
      },
      {
        label: "7 days",
        value: "P7D",
      },
      {
        label: "14 days",
        value: "P14D",
      },
      {
        label: "21 days",
        value: "P21D",
      },
      {
        label: "1 month",
        value: "P1M",
      },
      {
        label: "1.5 months",
        value: "P1M14D",
      },
      {
        label: "2 months",
        value: "P2M",
      },
      {
        label: "3 months",
        value: "P3M",
      },
    ];

    if (allowManual) {
      items.unshift({
        label: "manual",
        value: undefined,
        key: "manual",
      });
    }

    items.forEach(item => {
      item.key = item.key || item.value;
    });

    return items;
  }, [allowManual]);

  return (
    <DropdownField<ISO8601Duration | undefined>
      field={field}
      label={label}
      fluid={fluid}
      isMobile={isMobile}
      className="polly-authoring__dropdown"
      selectedItemLabel={item => {
        if (!item.label && !item.value) {
          return "manual";
        }
        if (!item.label && item.value) {
          return moment.duration(item.value).humanize();
        }
        return item.label;
      }}
      items={options}
    />
  );
};
